export const configuration = {
  projectName : {
    firstName: 'Project',
    lastName: 'Name',
    minimalName: 'PN'
  },
  localStorageKey: 'PROJECT-NAME-APP',
  logoPath: '',
  skin: 'skin-blue',
  userDefaultImage: 'assets/default-user.png',
  logoDefaultImage: 'assets/QtraqLogo.png',
  logosmallImage: 'assets/logosmall.png',
  serverErrorEndpoint: '',
};

// -- Avaiable Skins
// skin-blue
// skin-blue-light
// skin-yellow
// skin-yellow-light
// skin-green
// skin-green-light
// skin-purple
// skin-purple-light
// skin-red
// skin-red-light
// skin-black
// skin-black-light



// WEBPACK FOOTER //
// ./src/app/configuration.ts